export default {
    responses: {
        SI: 'Sí',
        NO: 'No',
        DESEMPLEADO: 'Sin ingresos en actividad laboral o profesional',
        JUBILADO: 'Jubilado',
        SALARIO: 'Salario',
        ESTUDIANTE: 'Estudiante',
        MENOR: 'Menor',
        CUENTA_PROPIA: 'Empleado por cuenta propia',
        CUENTA_AJENA: 'Empleado por cuenta ajena',
        EDUCACION_BASICA: 'Educación básica',
        EDUCACION_NO_OBLIGATORIA: 'Educación no obligatoria',
        EDUCACION_SUPERIOR: 'Educación superior o universitaria',
        EDUCACION_SUPERIOR_CCEE: 'Educación superior o universitaria ámbito economía',
        BAZARES: 'Bazares',
        COMERCIANTES_ARTE: 'Comerciantes de arte',
        INDUSTRIA_TABACALERA: 'Industria tabacalera',
        ANTICUARIO: 'Anticuario',
        LOCALES_NOCTURNOS: 'Locales nocturnos',
        BANCA_CORRESPONSAL: 'Banca corresponsal',
        LOCUTORIO: 'Locutorio',
        DINERO_ELECTRONICO: 'Dinero electrónico y pasarelas de pago',
        FIRMAS_AUDITORIA: 'Firmas de auditoría',
        ADMINISTRACIONES_PUBLICAS: 'Administraciones públicas',
        CASA_CAMBIO_MONEDA: 'Casa de cambio de moneda y servicios de envío de dinero',
        COMERCIO_ELECTRONICO: 'Comercio electrónico',
        CONSTRUCCION_INMOBILIARIA: 'Construcción/Inmobiliaria',
        IMPEXP_AUTOMOVILES: 'Importación/exportación automóviles',
        RECICLADO_METALES: 'Reciclado de metales',
        OTROS_INTERMEDIARIOS_FINANCIEROS: 'Otros intermediarios financieros',
        DEPORTISTAS_PROFESIONALES: 'Deportistas profesionales',
        CASINO: 'Casino',
        COMERCIO_METALES_JOYERIA: 'Comercio metales preciosos/joyería',
        ABOGADOS_OTROS:
            '*Abogados, procuradores, asesores fiscales y otros profesionales independientes',
        VENTA_PORMAYOR: 'Venta al por mayor',
        FABRICACION_ARMAS: 'Fabricación o distribución de armas',
        OTROS: 'Otros',
        ACTIVIDAD_EMPRESARIAL: 'Actividad empresarial',
        VENTA_BIENES: 'Venta de bienes',
        INDEMNIZACION: 'Indemnización',
        DONACION: 'Donación',
        HERENCIA: 'Herencia',
        AHORROS: 'Ahorros',
        INGRESOS_CONYUGE: 'Ingresos del cónyuge',
        PENSION: 'Pensión',
        MENOS_500K: 'Menos de 500.000 euros',
        ENTRE_500K_5M: 'Entre 500.000 euros y 5 millones de euros',
        ENTRE_5M_40M: 'Entre 5 y 40 millones de euros',
        MAS_40M: 'Más de 40 millones de euros',
        MENOS_50K: 'Menos de 50.000 euros',
        MENOS_40K: 'Menos de 40.000 euros',
        ENTRE_40K_80K: 'Entre 40.000 y 80.000 euros',
        ENTRE_80K_150K: 'Entre 80.000 y 150.000 euros',
        MAS_150K: 'Más de 150.000 euros',
        MENOS_60K: 'Menos de 60.000 euros',
        ENTRE_60K_120K: 'Entre 60.000 y 120.000 euros',
        ENTRE_120K_250K: 'Entre 120.000 y 250.000 euros',
        ENTRE_250K_1M: 'Entre 250.000 y 1.000.000 euros',
        MAS_1M: 'Más de 1.000.000 euros',
        ENTRE_50K_500K: 'Entre 50.000 y 500.000 euros',
        ENTRE_500K_2M: 'Entre 500.000 y 2 millones de euros',
        MAS_2M: 'Más de 2 millones de euros',
        ENTRE_10K_50K: 'Entre 10.000 y 50.000 euros',
        MAS_500K: 'Más de 500.000 euros',
        MENOS_10K: 'Menos de 10.000 euros',
        MENOS_5_PERSONAS: 'Menos de 5 personas',
        ENTRE_5_15_PERSONAS: 'Entre 5 y 15 personas',
        ENTRE_16_30_PERSONAS: 'Entre 16 y 30 personas',
        MAS_30_PERSONAS: 'Más de 30 personas',
        NO_FINANCIERA_ACTIVA:
            'La entidad es una Entidad no financiera y activa (al menos un 50% de sus rentas pueden calificarse como ingresos operativos)',
        NO_FINANCIERA_PASIVA:
            'La entidad es una Entidad no financiera y pasiva (menos de un 50% de sus rentas pueden calificarse como ingresos operativos)',
        FINANCIERA_GIN:
            'La entidad es una institución financiera obligada a comunicar información y dispone de número GIIN arriba indicado',
        INSTITUCION_FATCA_GIN:
            'La entidad es una Institución que tiene delegadas el cumplimiento de sus obligaciones FATCA en una Sponsoring entity con número GIIN arriba indicado',
        INSTITUCION_NO_FATCA: 'La entidad es una Institución financiera no partícipe con FATCA',
        INSTITUCION_EXCEPTUADA:
            'La entidad es una institución financiera no obligada a comunicar información, una Institución financiera considerada cumplidora, o un beneficiario efectivo execto o una Institución financiera exceptuada. ',
        INSTITUCION_OFI:
            'La entidad es una Institución financiera con titulares documentados que sean personas estadounidenses específicas (Owner-documented Financial Institution)',
        ENTIDAD_PERSONA_ESTADOUNIDENSE: 'La entidad es una persona estadounidense',
        ENTIDAD_NO_CLASIFICADA:
            'La entidad no se encuentra en ninguna de las clasificaciones anteriores. Y dispone de un número GIIN arriba indicado.',
        MUY_CORTO_PLAZO: 'Muy corto plazo - Menos de un año',
        CORTO_PLAZO: 'Corto plazo - Entre 1 y 3 años',
        MEDIO_PLAZO: 'Medio plazo - Entre 3 y 5 años',
        LARGO_PLAZO: 'Largo plazo - Más de 5 años',
        RENTA_FIJA:
            'Depósitos, imposiciones e instrumentos de renta fija (bonos, letras, fondos de inversión  y planes de pensiones)',
        RENTA_VARIABLE:
            'Instrumentos de renta variable ( acciones, SICAV, fondos de inversión y planes de pensiones)',
        FONDOS_INVERSION_LIBRE:
            'Fondos de inversión libre - hedge funds, productos estructurados, productos derivados.'
    },
    questions: {
        TIENE_NIF_EEUU: '¿Tiene número de identificación fiscal en EEUU?',
        TIENE_SEGUNDO_PAIS_OBLIGACION_FISCAL:
            '¿Tiene un segundo país con obligaciones fiscales por residencia o ciudadanía?',
        MARQUE_OPCION: 'Marque por favor la opción que corresponda.',
        SITUACION_LABORAL: '¿Cuál es su situación laboral u ocupación?',
        NOMBRE_ADMINISTRADORES:
            'Si no existe ninguna persona física que posea o controle directa o indirectamente un porcentaje igual o superior al 25% del capital social o de los derechos de voto de la persona jurídica, indique el nombre de todos los administradores:',
        NOMBRE_PERSONAS_25_MAS:
            'Si el inversor es una Fundación, ONG, Entidad Religiosa o Asociación, debe indique la persona o personas físicas que controlen un 25% o más de los derechos de voto del Patronato, junta directiva u órgano de representación:',
        NOMBRE_PERSONAS_25_MENOS:
            'Si no existe ninguna persona física que posea o controle un 25% o más de los derechos de voto del Patronato, junta directiva u órgano de representación, indique el nombre de todos los Patronos o miembros del órgano de representación',
        SOCIEDAD_NIF_EEUU: '¿La sociedad tiene número de identificación fiscal en EEUU?',
        INDIQUE_EMPRESA: 'Indique empresa',
        INDIQUE_CARGO: 'Indique cargo',
        DESARROLLA_ACTIVIDAD_SECTORES:
            '¿Desarrolla o ha desarrollado actividad en alguno de los siguientes sectores?',
        ESPECIFIQUE_SECTOR: 'Especifique el sector',
        ORIGEN_PATRIMONIO: '¿Cuál es el origen del patrimonio a invertir?',
        ESPECIFIQUE_ORIGEN: 'Especifique el origen',
        HA_SIDO_DIRECTIVO:
            '¿Ha sido directivo de alguna ONG o fundación, persona de responsabilidad pública familiar o allegado, en los dos últimos años?',
        HA_SIDO_DIRECTIVO_ONG: '¿Ha sido directivo de alguna ONG o fundación?',
        HA_SIDO_RESPONSABILIDAD_PUBLICA:
            '¿Ha sido persona de responsabilidad pública (familiares o allegados incluidos)¹ en los dos últimos años?',
        NOTA_FAMILIARES:
            '¹ La consideración de familiar comprende el cónyuge o la persona ligada de forma estable por análoga relación de afectividad, así como los padres e hijos, y los cónyuges o personas ligadas a los hijos de forma estable por análoga relación de afectividad.',
        BENEFICIO_EJERCICIO_ANTERIOR: '¿Qué beneficio obtuvo en el ejercicio anterior?',
        VOLUMEN_FONDOS_PROPIOS: '¿Cuál es su volumen de Fondos Propios?',
        CUANTOS_EMPLEADOS: '¿Con cuántos empleados cuenta la sociedad?',
        OPERA_EN_PAISES: '¿Opera principalmente en alguno de estos países?',
        PERSONAS_SOCIEDAD_25_MAS:
            'Indique las personas físicas que en último término poseen o controlan un porcentaje igual o superior al 25% del capital social o de los derechos de voto. Si no existiese ninguna, indique el nombre de todos los administradores',
        PERSONAS_FUNDACION_25_MAS:
            'Si el inversor es una fundación, ONG, entidad religiosa o asociación, debe indicar la persona o personas físicas que controlen un 25% o mas de los derechos de voto del patronato, junta directiva u órgano de representación. Si no existiese ninguna indique el nombre de todos los patrones o miembros del órgano de representación',
        SOCIEDAD_ACTIVIDAD_SECTORES:
            '¿La sociedad desarrolla o ha desarrollado actividad en alguno de los siguientes sectores?',
        INDIQUE_SECTOR: 'Indique sector',
        SOCIEDAD_SEGUNDO_PAIS_FISCAL:
            '¿La sociedad tiene un segundo país con obligaciones fiscales por residencia o ciudadanía?',
        PRODUCTOS_FINANCIEROS_3_ANOS:
            '¿En qué productos financieros ha invertido en al menos dos ocasiones en los últimos tres años?',
        HORIZONTE_TEMPORAL_INVERSION: '¿Cuál es su horizonte temporal de inversión?',
        INDIQUE_ORGANIZACION: 'Indique la organización',
        INDIQUE_NUMERO_TIN: 'Indique el número TIN',
        INDIQUE_EN_CUALES: 'Indique en cuales',
        INDIQUE_NUMERO_GIIN: 'Indique el número GIIN',
        INDIQUE_PAIS_NIF: 'Indique país y número de identificación fiscal',
        INDIQUE_CONSIDERACION: 'Indique su consideración',
        OBLIGADO_PBC_FT:
            '*¿Es Usted sujeto obligado en materia de PBC/FT en virtud de las previsiones contenidas en el art. 2.1. ñ) de la Ley 10/2010?',
        INGRESOS_ANUALES: '¿Cuáles son sus ingresos anuales?',
        PATRIMONIO_FINANCIERO:
            '¿Cuál es su patrimonio financiero aproximado? No incluye inmuebles ni préstamos',
        NIVEL_FORMACION: '¿Cuál es su nivel de formación?',
        CIFRA_ANUAL_ANTERIOR: '¿Cuál fue su cifra anual de negocio en el ejercicio anterior?',
        SOCIEDAD_OPERA_GAFI:
            '¿La sociedad opera principalmente en países, territorios o jurisdicciones de riesgo (GAFI)?',
        INDIQUE_PAISES: 'Indique paises',
        NORMATIVA_FATCA: 'Normativa FATCA. ¿Tiene número de identificación fiscal en EE UU?',
        NORMATIVA_CRS:
            'Normativa CRS. ¿Tiene obligaciones fiscales por residencia o ciudadanía en otro país que no fuera España?',
        NORMATIVA_FATCA_JUR: 'Marque la casilla que corresponda.',
        INDIQUE_PAIS: 'Indique país',
        INDIQUE_NIF: 'Indique número de identificación fiscal',
        INDIQUE_TIPO_ENTIDAD: 'Indique como debe considerarse a la entidad'
    }
};
